import { BiteLogTseCampusCardEvent } from './bite_log_tse_campus_card_event.js';

export function name(event: BiteLogTseCampusCardEvent): string {
  switch (event) {
    case BiteLogTseCampusCardEvent.BalanceInquirySuccess:
      return 'balance-inquiry-success';
    case BiteLogTseCampusCardEvent.BalanceInquiryError:
      return 'balance-inquiry-error';
    case BiteLogTseCampusCardEvent.SaleTransaction:
      return 'sale-transaction';
    case BiteLogTseCampusCardEvent.SaleTransactionError:
      return 'sale-transaction-error';
    case BiteLogTseCampusCardEvent.RefundTransaction:
      return 'refund-transaction';
    case BiteLogTseCampusCardEvent.RefundTransactionError:
      return 'refund-transaction-error';
    case BiteLogTseCampusCardEvent.AuthorizeLimitSuccess:
      return 'authorize-limit-success';
    case BiteLogTseCampusCardEvent.AuthorizeLimitError:
      return 'authorize-limit-error';
    case BiteLogTseCampusCardEvent.RetryAttempt:
      return 'retry-attempt';
    case BiteLogTseCampusCardEvent.ConnectError:
      return 'connect-error';
    case BiteLogTseCampusCardEvent.ParseError:
      return 'parse-error';
    default:
      return 'unknown';
  }
}
